import { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
interface BarProps {
	value: string;
	type: string;
	service: string;
	index: number;
	isActive: boolean;
	formattedDate: string | false;
	onMouseEnter: (index: number) => void;
	onMouseLeave: () => void;
	renderTooltipContent: (data: any) => JSX.Element;
}

const Bar: React.FC<BarProps> = ({
	value,
	index,
	type,
	service,
	isActive,
	formattedDate,
	onMouseEnter,
	onMouseLeave,
	renderTooltipContent,
}) => {
	const [flipped, setFlipped] = useState("right");
	const tooltipRef = useRef<HTMLDivElement>(null);

	const { t } = useTranslation();

	const barClass = {
		Green: "bar-green",
		Orange: "bar-yellow",
		Red: "bar-red",
		undefined: "bar-gray",
	};

	const statusTitle = {
		Green:
			type === "daily"
				? (t('bar.statusTitleDay'))
				: (t('bar.statusTittleTime')),
		Orange: (t('bar.statusTittleTechnicalIssues')),
		Red: (t('bar.statusTittleOutage', { service })),
		undefined: (t('bar.statusTittleNoData')),
	};

	const checkTooltipPosition = useCallback(() => {
		if (tooltipRef.current) {
			const tooltip = tooltipRef.current.getBoundingClientRect();
			if (tooltip.right + 150 > window.innerWidth) {
				setFlipped("left");
			} else if (tooltip.left < 0) {
				setFlipped("right");
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [window.innerWidth]);

	useEffect(() => {
		checkTooltipPosition();
	}, [isActive, checkTooltipPosition]);

	return (
		<div
			className={`bar ${barClass[value]}`}
			onMouseEnter={() => onMouseEnter(index)}
			onFocus={() => onMouseEnter(index)}
			onBlur={onMouseLeave}
			onMouseLeave={onMouseLeave}
			tabIndex={-1} 
			aria-describedby={isActive ? `tooltip-${index}` : undefined}
		>
			{isActive && (
				<div
					className={`tooltip ${flipped === "left" ? "left-tooltip" : "right-tooltip"}`}
					ref={tooltipRef}
					role="tooltip"
					id={`tooltip-${index}`}
				>
					<span
						className={`tooltip-arrow ${flipped === "left" ? "left-arrow" : "right-arrow"}`}
					></span>
					{renderTooltipContent({
						date: formattedDate,
						statusTitle: statusTitle[value],
					})}
				</div>
			)}
		</div>
	);
};

export default Bar;
